import { DictionaryItem, Region } from '../typings/common';
import { RegionsSearchEditorState } from '../typings/regionsSearchEditor';

export const INIT_REGIONS_SEARCH_EDITOR = 'INIT_REGIONS_SEARCH_EDITOR';
export type INIT_REGIONS_SEARCH_EDITOR = typeof INIT_REGIONS_SEARCH_EDITOR;

export interface InitRegionsSearchEditor {
    type: INIT_REGIONS_SEARCH_EDITOR;
    editorId: string;
    value: RegionsSearchEditorState;
}

export function initRegionsTransformEditor(editorId: string, value: RegionsSearchEditorState): InitRegionsSearchEditor {
    return {
        type: INIT_REGIONS_SEARCH_EDITOR,
        editorId,
        value
    };
}

export const CHANGE_SEARCH_VALUE_FOR_REGIONS_SEARCH_EDITOR = 'CHANGE_SEARCH_VALUE_FOR_REGIONS_SEARCH_EDITOR';
export type CHANGE_SEARCH_VALUE_FOR_REGIONS_SEARCH_EDITOR = typeof CHANGE_SEARCH_VALUE_FOR_REGIONS_SEARCH_EDITOR;

export interface ChangeSearchValueForRegionsSearchEditor {
    type: CHANGE_SEARCH_VALUE_FOR_REGIONS_SEARCH_EDITOR;
    editorId: string;
    searchValue: string;
    regionTree?: Region[];
}

export function changeSearchValueForRegionsSearchEditor(
    editorId: string,
    searchValue: string,
    regionTree?: Region[]
): ChangeSearchValueForRegionsSearchEditor {
    return {
        type: CHANGE_SEARCH_VALUE_FOR_REGIONS_SEARCH_EDITOR,
        editorId,
        searchValue,
        regionTree
    };
}

export const CHANGE_SUGGEST_ITEMS_FOR_REGIONS_SEARCH_EDITOR = 'CHANGE_SUGGEST_ITEMS_FOR_REGIONS_SEARCH_EDITOR';
export type CHANGE_SUGGEST_ITEMS_FOR_REGIONS_SEARCH_EDITOR = typeof CHANGE_SUGGEST_ITEMS_FOR_REGIONS_SEARCH_EDITOR;

export interface ChangeSuggestItemsForRegionsSearchEditor {
    type: CHANGE_SUGGEST_ITEMS_FOR_REGIONS_SEARCH_EDITOR;
    editorId: string;
    searchSuggestItems: DictionaryItem[];
}

export function changeSuggestItemsForRegionsSearchEditor(
    editorId: string,
    searchSuggestItems: DictionaryItem[]
): ChangeSuggestItemsForRegionsSearchEditor {
    return {
        type: CHANGE_SUGGEST_ITEMS_FOR_REGIONS_SEARCH_EDITOR,
        editorId,
        searchSuggestItems
    };
}

export const SELECT_SUGGEST_ITEM_FOR_REGIONS_SEARCH_EDITOR = 'SELECT_SUGGEST_ITEM_FOR_REGIONS_SEARCH_EDITOR';
export type SELECT_SUGGEST_ITEM_FOR_REGIONS_SEARCH_EDITOR = typeof SELECT_SUGGEST_ITEM_FOR_REGIONS_SEARCH_EDITOR;

export interface SelectSuggestItemForRegionsSearchEditor {
    type: SELECT_SUGGEST_ITEM_FOR_REGIONS_SEARCH_EDITOR;
    editorId: string;
    nodeId: string;
    regionTree?: Region[];
}

export function selectSuggestItemForRegionsSearchEditor(
    editorId: string,
    nodeId: string,
    regionTree?: Region[]
): SelectSuggestItemForRegionsSearchEditor {
    return {
        type: SELECT_SUGGEST_ITEM_FOR_REGIONS_SEARCH_EDITOR,
        editorId,
        nodeId,
        regionTree
    };
}

export const DESELECT_SUGGEST_ITEM_FOR_REGIONS_SEARCH_EDITOR = 'DESELECT_SUGGEST_ITEM_FOR_REGIONS_SEARCH_EDITOR';
export type DESELECT_SUGGEST_ITEM_FOR_REGIONS_SEARCH_EDITOR = typeof DESELECT_SUGGEST_ITEM_FOR_REGIONS_SEARCH_EDITOR;

export interface DeselectSuggestItemForRegionsSearchEditor {
    type: DESELECT_SUGGEST_ITEM_FOR_REGIONS_SEARCH_EDITOR;
    editorId: string;
    nodeId: string;
}

export function deselectSuggestItemForRegionsSearchEditor(
    editorId: string,
    nodeId: string
): DeselectSuggestItemForRegionsSearchEditor {
    return {
        type: DESELECT_SUGGEST_ITEM_FOR_REGIONS_SEARCH_EDITOR,
        editorId,
        nodeId
    };
}

export const APPLY_SEARCH_VALUE_FOR_REGIONS_SEARCH_EDITOR = 'APPLY_SEARCH_VALUE_FOR_REGIONS_SEARCH_EDITOR';
export type APPLY_SEARCH_VALUE_FOR_REGIONS_SEARCH_EDITOR = typeof APPLY_SEARCH_VALUE_FOR_REGIONS_SEARCH_EDITOR;

export interface ApplySearchValueForRegionsSearchEditor {
    type: APPLY_SEARCH_VALUE_FOR_REGIONS_SEARCH_EDITOR;
    editorId: string;
    searchValue: string;
    regionTree?: Region[];
}

export function applySearchValueForRegionsSearchEditor(
    editorId: string,
    searchValue: string,
    regionTree?: Region[]
): ApplySearchValueForRegionsSearchEditor {
    return {
        type: APPLY_SEARCH_VALUE_FOR_REGIONS_SEARCH_EDITOR,
        editorId,
        searchValue,
        regionTree
    };
}

export const CLEAR_REGIONS_SEARCH_EDITOR = 'CLEAR_REGIONS_SEARCH_EDITOR';
export type CLEAR_REGIONS_SEARCH_EDITOR = typeof CLEAR_REGIONS_SEARCH_EDITOR;

export interface ClearRegionsSearchEditor {
    type: CLEAR_REGIONS_SEARCH_EDITOR;
    editorId: string;
}

export function clearRegionsSearchEditor(editorId: string): ClearRegionsSearchEditor {
    return {
        type: CLEAR_REGIONS_SEARCH_EDITOR,
        editorId
    };
}

export type RegionsSearchEditorAction =
    | InitRegionsSearchEditor
    | ChangeSearchValueForRegionsSearchEditor
    | ChangeSuggestItemsForRegionsSearchEditor
    | SelectSuggestItemForRegionsSearchEditor
    | DeselectSuggestItemForRegionsSearchEditor
    | ApplySearchValueForRegionsSearchEditor
    | ClearRegionsSearchEditor;
